export type PaymentTab = 'Cash' | 'Card' | 'UPI' | 'Redeem Points' | 'Split';

export interface CardDetails {
  name: string | null;
  number: number;
  expiry: string | null;
  amount: number | null;
  transactionId: string | null;
}

export interface UpiDetails {
  upiId: string | null;
  upiAmount: number;
  transactionId: string | null;
}

export interface SplitPaymentAmounts {
  cash: number;
  card: number;
  upi: number;
}

/**
 * PaymentSessionState
 *
 * The payment-tab state machine for the Payment Total Dialog: which tab is
 * active, the entered amounts per method, part-payment toggles, and the
 * redeem-credit fields. Owned by PaymentSessionService (scoped to the
 * dialog's lifecycle) rather than DashboardComponent — these fields are
 * read/written only by payment-tab methods.
 */
export interface PaymentSessionState {
  activePaymentTab: PaymentTab;
  selectedPaymentOptions: string | string[] | null;
  isPartPaymentCash: boolean;
  isPartPaymentCard: boolean;
  isPartPaymentUPI: boolean;
  cashAmount: number;
  cardDetails: CardDetails;
  upiDetails: UpiDetails;
  splitPaymentAmounts: SplitPaymentAmounts;
  redeemCreditAmount: number;
  availableCreditAmount: number;
  refundCashAmount: number;
  selectedInvoiceNo: string;
}

export function createDefaultPaymentSessionState(): PaymentSessionState {
  return {
    activePaymentTab: 'Cash',
    selectedPaymentOptions: ['Cash'],
    isPartPaymentCash: false,
    isPartPaymentCard: false,
    isPartPaymentUPI: false,
    cashAmount: 0,
    cardDetails: {
      name: null,
      number: 0,
      expiry: null,
      amount: null,
      transactionId: null,
    },
    upiDetails: {
      upiId: null,
      upiAmount: 0,
      transactionId: null,
    },
    splitPaymentAmounts: {
      cash: 0,
      card: 0,
      upi: 0,
    },
    redeemCreditAmount: 0,
    availableCreditAmount: 0,
    refundCashAmount: 0,
    selectedInvoiceNo: '',
  };
}
